import { requester } from '../utils';
import cookies from 'js-cookie';

export const getAllCafes = (cityCode) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/dynamics`,
        method: 'POST',
        withAuth: false,
        cityCode: cityCode,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get cafes error', err);
        reject(err);
      });
  });
};

export const getCafeDetails = (id) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/details/${id}`,
        method: 'GET',
        withAuth: false,
      })
      .then((result) => {
        cookies.set('cafe-id', result.payload.id);
        ///Added manHourPrepaidPrice to Cookie
        cookies.set('man-prepaid-price', result.payload.manHourPrepaidPrice.value);

        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get cafe\'s details error', err);
        reject(err);
      });
  });
};

export const searchCafes = (withAuth, cityCode, data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/cafe/search',
        method: 'POST',
        withAuth: withAuth,
        cityCode: cityCode,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('search cafe\'s error', err);
        reject(err);
      });
  });
};

export const cafeNamesListAndFilter = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/cafe/names',
        method: 'POST',
        withAuth: false,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('cafe\'s names list and filter error', err);
        reject(err);
      });
  });
};

export const getDynamicCafesByType = (withAuth, cityCode, data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/cafe/type',
        method: 'POST',
        withAuth: withAuth,
        cityCode: cityCode,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get dynamic cafes list by type\'s error', err);
        reject(err);
      });
  });
};
